import React from 'react'
import { DeleteSourceNameConfirmation } from '../delete-source-name-confirmation'
import { CsDeleteIcon } from '../../../legacy-design-system/icons'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export function ActionsCell({
  organizationID,
  refetch,
  rowData: { id, name }
}: {
  readonly organizationID: string
  readonly refetch: () => Promise<any>
  readonly rowData: {
    readonly id: string
    readonly name: string
  }
}) {
  return (
    <div
      data-e2e="delete-button"
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <DeleteSourceNameConfirmation
        sourceName={{
          id,
          name
        }}
        organizationID={organizationID}
        onSuccess={refetch}
      >
        {({ setIsOpen }) => (
          <CsDeleteIcon
            size={17}
            className={css`
              cursor: pointer;
              color: ${theme.color.neutral100};
            `}
            onClick={() => setIsOpen(true)}
          />
        )}
      </DeleteSourceNameConfirmation>
    </div>
  )
}
